import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createPneumologyDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterPneumologyFormSchema } from "./schema";
import { DischargeLetterPneumologyFormSections } from "./sections";

export const getDischargeLetterPneumologyFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_PNEUMOLOGY
> = () => {
  return {
    config: { canPrint: false, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        additional_diagnostic_findings:
          value?.additional_diagnostic_findings ?? "",
        admission_medications: value?.admission_medications ?? "",
        admission_reason: value?.admission_reason ?? "",
        anamnesis: value?.anamnesis ?? "",
        clinical_examination: value?.clinical_examination ?? "",
        concluding_remarks: value?.concluding_remarks ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        discharge_summary: value?.discharge_summary ?? "",
        next_provider: value?.next_provider ?? "",
        parameters: value?.parameters ?? "",
        prescribed_regulations: value?.prescribed_regulations ?? "",
        recommendations: value?.recommendations ?? "",
        therapy: value?.therapy ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formPneumology.title,
    pdfConfig: {
      downloadPdfFileName: (translations) =>
        translations.extractDocs.dischargeLetter.generatedPdf
          .savedFileNamePneumology,
      pdfCreator: createPneumologyDischargeLetterPdf,
    },
    schema: DischargeLetterPneumologyFormSchema,
    sections: DischargeLetterPneumologyFormSections,
  };
};
